import Vue from 'vue';
import ImageCarousel from "./ImageCarousel";
import getStamp from "../stamp/get-stamp";

const types = ['landscape', 'portrait', 'square'];

/**
 * Instantiates image carousel for every element on page with .image-carousel class
 */
$('.image-carousel').each((index, carousel) => {
    const $carousel = $(carousel);
    const images = [];

    $carousel.children('img').each((index, img) => {
        images.push($(img).attr('src'));
    });

    const type = types.find(t => $carousel.hasClass(t)) || types[0];

    const stamp = getStamp($carousel);

    new Vue({
        render (h) {
            return h(ImageCarousel, {
                props: {
                    images: images,
                    type: type,
                    ...stamp,
                }
            });
        }
    }).$mount(carousel);
});
